import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialog as MatDialog,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Component({
	selector: 'app-search-contacts-dialog',
	templateUrl: './search-contacts-modal.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class SearchContactsDialogComponent implements OnInit {
	isUpdating = false;
	selectedContact = null;
	contactList = null;
	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;

	constructor(
		public dialogRef: MatDialogRef<SearchContactsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.contactList = this.data.contactList;
	}

	closeDialog() {
		this.dialogRef.close();
	}

	contactSelected(selectedContact: any) {
		this.selectedContact = selectedContact;
	}

	selectContactForProject() {
		this.dialogRef.close(this.selectedContact);
	}
}
